import { call, put, takeEvery } from "redux-saga/effects";
import Constants from "../../Action/Constants";
import { ActionInterface } from "../../Interface/ActionInterface";
import { ErrorHandlerSequence } from "../Sequences/ErrorHandlerSequence";
import Http from "../../Http/Http";

export default function* eventHide(action: ActionInterface): any {
  try {
    yield call(Http.put, `event/hide/${action.payload?.event.id}`);

    // Automatically hide it on the first machine so it feels faster for end user.
    yield put({
      type: Constants.GLOBAL_EVENT_HIDE_SUCCESS,
      payload: {
        event: action.payload?.event.reinitialize({ hidden: true })
      }
    });

    yield put({
      type: Constants.GLOBAL_EVENTS_LIST_OUTDATE_REQUESTS
    })
  } catch (err) {
    yield ErrorHandlerSequence(err, action);
  }
}

export function* watchEventHide() {
  yield takeEvery(Constants.GLOBAL_EVENT_HIDE_START, eventHide);
}
